export var EditableState;
(function (EditableState) {
    EditableState["Edit"] = "edit";
    EditableState["Move"] = "move";
})(EditableState || (EditableState = {}));
